import React from "react";
import facebookSvg from "images/Facebook.svg";
import twitterSvg from "images/Twitter.svg";
import { useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form";
import googleSvg from "images/Google.svg";
import cogoToast from "cogo-toast";
import Input from "components/Input/Input";
import { BACKEND_URL } from "../../../constants";
import ButtonPrimary from "components/Button/ButtonPrimary";
import NcLink from "components/NcLink/NcLink";
import Heading2 from "components/Heading/Heading2";
import Image from "components/Image";
import Layout from "../layout";

const loginSocials = [
  {
    name: "Continue with Facebook",
    href: "#",
    icon: facebookSvg,
  },
  {
    name: "Continue with Twitter",
    href: "#",
    icon: twitterSvg,
  },
  {
    name: "Continue with Google",
    href: "#",
    icon: googleSvg,
  },
];

const PageSignUp = () => {
  const navigate = useNavigate()
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      name: "",
      surname:"",
      email: "",
      password: "",
    },
  });
  
    const handleMouseEvent = (e) => {
      e.preventDefault();
      const data = getValues();
      if(data.name == "" || data.surname == "" || data.email == "" || data.password == ""){
        cogoToast.info("Prosze wypełnić formularz")
      }
      else{
        fetch(`${BACKEND_URL}/register`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: data.name,
            surname: data.surname,
            email: data.email,
            password: data.password,
          }),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.statusCode === 200) {
              cogoToast.success("Użytkownik utworzony. Teraz możesz sie zalogować");
              setTimeout(() => {
                navigate("/login")
              }, [2000]);
            } else if (response.statusCode === 400) {
              cogoToast.error("Email jest już zajęty");
            }
          });
      }
    };
  return (
    <Layout>
      <header className="text-center max-w-2xl mx-auto - mb-14 sm:mb-16 lg:mb-20">
        <Heading2>Rejestracja</Heading2>
        <span className="block text-sm mt-2 text-neutral-700 sm:text-base dark:text-neutral-200">
         Witamy w naszym portalu
        </span>
      </header>

      <div className="max-w-md mx-auto space-y-6">
        {/* <div className="grid gap-3">
          {loginSocials.map((item, index) => (
            <a
              key={index}
              href={item.href}
              className=" flex w-full rounded-lg bg-primary-50 dark:bg-neutral-800 px-4 py-3 transform transition-transform sm:px-6 hover:translate-y-[-2px]"
            >
              <Image
                className="flex-shrink-0"
                src={item.icon}
                alt={item.name}
              />
              <h3 className="flex-grow text-center text-sm font-medium text-neutral-700 dark:text-neutral-300 sm:text-sm">
                {item.name}
              </h3>
            </a>
          ))}
        </div> */}
        {/* <div className="relative text-center">
          <span className="relative z-10 inline-block px-4 font-medium text-sm bg-white dark:text-neutral-400 dark:bg-neutral-900">
            Lub
          </span>
          <div className="absolute left-0 w-full top-1/2 transform -translate-y-1/2 border border-neutral-100 dark:border-neutral-800"></div>
        </div> */}
        {/* FORM */}
        <form className="grid grid-cols-1 gap-6" action="#" method="post">
        <label className="block">
            <span className="text-neutral-800 dark:text-neutral-200">
              Imie
            </span>
            <Input
             {...register("name", {
              required: { value: true, message: "Pole wymagane" },
              maxLength: 20,
              minLength: 3,
            })}
              type="text"
              placeholder="John"
              className="mt-1"
            />
          </label>
          <label className="block">
            <span className="text-neutral-800 dark:text-neutral-200">
              Nazwisko
            </span>
            <Input
             {...register("surname", {
              required: { value: true, message: "Pole wymagane" },
              maxLength: 20,
              minLength: 3,
            })}
              type="text"
              placeholder="John"
              className="mt-1"
            />
          </label>
          <label className="block">
            <span className="text-neutral-800 dark:text-neutral-200">
              E-mail
            </span>
            <Input
             {...register("email", {
              required: { value: true, message: "Pole wymagane" },
              maxLength: 20,
              minLength: 3,
            })}
              type="email"
              placeholder="example@example.com"
              className="mt-1"
            />
          </label>
          <label className="block">
            <span className="flex justify-between items-center text-neutral-800 dark:text-neutral-200">
              Hasło
            </span>
            <Input {...register("password", {
                            required: { value: true, message: "Pole wymagane" },
                            maxLength: 20,
                            minLength: 3,
                          })} type="password" className="mt-1" />
          </label>
        </form>
        <ButtonPrimary onClick={handleMouseEvent}>Zarejestruj się</ButtonPrimary>

        {/* ==== */}
        <span className="block text-center text-neutral-700 dark:text-neutral-300">
          Masz już konto? {` `}
          <NcLink href="/login">Zaloguj się</NcLink>
        </span>
      </div>
    </Layout>
  );
};

export default PageSignUp;
